

    import { defineComponent, ref, reactive, PropType, watch } from 'vue';
    import Day from '@Components/ArrivalDeparturePicker/Day.vue';

    import { MonthEntry } from './Types/MonthEntry';

    import appTranslations from "@Components/ArrivalDeparturePicker/Translations/VueTranslations"

    export default defineComponent({

        components: { Day },

        props: {


            month: {
                type: Object as PropType<MonthEntry>,
                required: true
            }

        },


        setup(props, context) {

            return {
                arrivalDeparturePicker_Label_2Char_Friday: appTranslations.arrivalDeparturePicker_Label_2Char_Friday,
                arrivalDeparturePicker_Label_2Char_Monday: appTranslations.arrivalDeparturePicker_Label_2Char_Monday,
                arrivalDeparturePicker_Label_2Char_Saturday: appTranslations.arrivalDeparturePicker_Label_2Char_Saturday,
                arrivalDeparturePicker_Label_2Char_Sunday: appTranslations.arrivalDeparturePicker_Label_2Char_Sunday,
                arrivalDeparturePicker_Label_2Char_Thursday: appTranslations.arrivalDeparturePicker_Label_2Char_Thursday,
                arrivalDeparturePicker_Label_2Char_Tuesday: appTranslations.arrivalDeparturePicker_Label_2Char_Tuesday,
                arrivalDeparturePicker_Label_2Char_Wednesday: appTranslations.arrivalDeparturePicker_Label_2Char_Wednesday
            };
        }

    });



